var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAttachedFileErrorLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33333 0.666992H8.27614L12 4.39085V14.0003C12 14.7367 11.403 15.3337 10.6667 15.3337H1.33333C0.596954 15.3337 0 14.7367 0 14.0003V2.00033C0 1.26395 0.596954 0.666992 1.33333 0.666992ZM6.66667 2.00033H1.33333V14.0003H10.6667V6.00033H8C7.26362 6.00033 6.66667 5.40337 6.66667 4.66699V2.00033ZM8 2.27647V4.66699H10.3905L8 2.27647ZM3.52857 7.80504L4.47138 6.86223L5.99998 8.39082L7.52857 6.86223L8.47138 7.80504L6.94278 9.33363L8.47138 10.8622L7.52857 11.805L5.99998 10.2764L4.47138 11.805L3.52857 10.8622L5.05717 9.33363L3.52857 7.80504Z",
  fill: "#EE6363"
})));
export { SvgAttachedFileErrorLogo as ReactComponent };
export default __webpack_public_path__ + "eb2e57427c84b9db78d3c5eb9d805b6d.svg";